// extracted by mini-css-extract-plugin
module.exports = {"container":"PlaybackControls_container__1iaru","playbackButton":"PlaybackControls_playbackButton__2tzg4","playbackControls":"PlaybackControls_playbackControls__23EWS"};